export const SUPPORTED_COMMANDS_API_URL = 'ui/partner/supported_commands';

export const supportedCommandsQueryKeys = {
  all: [SUPPORTED_COMMANDS_API_URL],
  published: () => [...supportedCommandsQueryKeys.all, 'published'],
};
